<template>
  <div class="em-block form-style" v-if="folder">
    <div v-if="this.viewMode" class="em-child">
      <h3>Menu Folder</h3>

      <h4>Folder Name</h4>
      <p>{{folder.name}}</p>

      <div class="cta">
        <button @click="edit" type="button" class="btn grey-to-blue block">
          <span class="icon pencil"></span>
          Edit
        </button>
      </div>
    </div>

    <div v-else class="em-child">
      <h3>Menu Folder</h3>

      <div>
        <label for="folder-name">Folder Name</label>
        <input v-model="tempFolder.name" type="text" id="folder-name">
      </div>

      <div class="cta">
        <button @click="cancel" type="button" class="btn red outline block">Cancel</button>
        <button @click="save" type="button" class="btn green block" :disabled="tempFolder.name.length < 1">Save</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import BookmarkFolder from "../../models/bookmarkFolder";
  import {ConfigureSidebarModes} from "../../enums/configureSidebarModes";
  import BookmarkMenuStoreMixinFactory from '../../mixins/bookmarkMenuStoreMixinFactory';
  import ConfigureSidebarInterfaceStoreMixin from "../../mixins/configureSidebarInterfaceStoreMixin";

  const bookmarkMenuStoreMixin = BookmarkMenuStoreMixinFactory({
    actions: [
      'updateBookmarkFolder',
    ],
  });

  export default Vue.extend({
    mixins: [
      bookmarkMenuStoreMixin,
      ConfigureSidebarInterfaceStoreMixin
    ],
    props: {
      folder: {
        type: BookmarkFolder,
        required: true
      }
    },
    data: function(): object {
      return {
        tempFolder: null,
      };
    },
    computed: {
      viewMode() {
        return this.interfaceMode === ConfigureSidebarModes.showFolder;
      }
    },
    created() {
      this.setTempFolder(this.folder);
    },
    watch: {
      folder(newValue) {
        this.setTempFolder(newValue)
      }
    },
    methods: {
      setTempFolder(folder) {
        if (this.folder) {
          if (this.tempFolder) { // TODO: maybe combine?
            this.tempFolder = this.tempFolder.loadFromJson(this.folder.asJson());
          } else {
            this.tempFolder = new BookmarkFolder().loadFromJson(this.folder.asJson())
          }
        }
      },
      edit(): void {
        this.setInterfaceMode({mode: ConfigureSidebarModes.editFolder, selected: this.folder});
      },
      cancel(): void {
        this.setInterfaceMode({mode: ConfigureSidebarModes.showFolder, selected: this.folder});
      },
      save(): void {
        this.folder.loadFromJson(this.tempFolder.asJson());
        this.updateBookmarkFolder({bookmarkFolder: this.folder}).then(() => {
          this.setInterfaceMode({mode: ConfigureSidebarModes.showFolder, selected: this.folder});
        });
      },
    },
  })
</script>